import { Icon } from "./Icon.tsx";

/** "Time Series" tab icon — axes plus an irregular, direction-changing line
 * (arbitrary observed data over time), unlike CurveIcon.tsx's own smooth
 * monotonic arc. */
export function TimeSeriesIcon() {
  return (
    <Icon>
      <path d="M4 4v16h16" />
      <path d="M4 16l3-5 3 3 3-7 3 4 4-6" />
    </Icon>
  );
}
